<template>
	<div class="layout--full-page">
		<div class="register">
			<div v-if="referrerValue && referrerName && step === 1" class="sponsorship">
				<p class="label_text" style="font-size: 13px; color: var(--black) !important">
					{{
						$t("Vous avez été parrainé par ... et bénéficiez de 30€ offerts", {
							referrerName: referrerName
						})
					}}
				</p>
			</div>
			<div v-if="step < 5" class="register_form_container">
				<!-- Affichage du label et de la pagination -->
				<transition name="pop">
					<div v-show="step <= 4" class="container_label">
						<p v-if="step === 1" class="label_text">{{ $t("Pour démarrer, entrez votre email") }}</p>
						<p v-if="step === 2" class="label_text">{{ $t("Choisissez votre mot de passe") }}</p>
						<p v-if="step === 3" class="label_text">{{ $t("Entrez votre prénom, nom") }}</p>
						<p v-if="step === 4" class="label_text">{{ $t("Enfin, précisez") }} :</p>

						<div class="etapes">
							<div class="step" :class="{ 'step-active': step === 1 }"></div>
							<div class="step" :class="{ 'step-active': step === 2 }"></div>
							<div class="step" :class="{ 'step-active': step === 3 }"></div>
							<div class="step" :class="{ 'step-active': step === 4 }"></div>
						</div>
					</div>
				</transition>

				<!-- Etape 1 : email et cgu -->
				<template v-if="step === 1">
					<div class="container_champs container_mail">
						<vs-input
							v-model="email"
							v-validate="'required|email'"
							:placeholder="$t('Email')"
							name="email"
							type="email"
							data-vv-scope="etape1"
							data-vv-delay="300"
							color="var(--black)"
							class="w-full no-icon-border"
							icon-pack="feather"
							icon="icon icon-mail"
							@keydown.enter="validateStep1"
							@focus="accountAlreadyExist = false"
						/>

						<div v-show="errors.has('etape1.email')" class="form_error">
							<strong class="font-semibold">{{ errors.first("etape1.email") }}</strong>
						</div>
					</div>

					<transition name="pop">
						<div class="container_checkbox">
							<p class="flex">
								<input
									id="cgu"
									v-model="cgu"
									v-validate="'included:1'"
									type="checkbox"
									name="cgu"
									class="mx-3 checkbox"
									data-vv-scope="etape1"
								/>
								<label for="cgu">
									{{ $t("J’ai lu et j’accepte les") }}
									<a
										href="#"
										class="text-lien"
										@click="openPage('cgu', false)"
										@keydown.enter="openPage('cgu', false)"
									>
										{{ $t("Conditions Générales d’Utilisation") }}
									</a>
								</label>
							</p>

							<div v-show="errors.has('etape1.cgu')" class="form_error">
								<strong class="font-semibold">{{ errors.first("etape1.cgu") }}</strong>
							</div>
						</div>
					</transition>

					<transition name="pop">
						<div v-if="accountAlreadyExist" class="container_accountAlreadyExist">
							<p style="font-weight: 600">
								{{
									$t(
										"Un compte utilisant cette adresse existe déjà, voulez vous plutôt vous connecter ?"
									)
								}}
								<!-- <br /> -->
								<!-- <s-button
									class="w-full vs-con-loading__container my-2 bgc-green"
									@click="openPage('login', true)"
									@keydown.enter="openPage('login', true)"
								>
									{{ $t("Me connecter") }}
								</s-button> -->
								<a
									href="#"
									style="color: var(--primary) !important"
									@click="openPage('login', true)"
									@keydown.enter="openPage('login', true)"
								>
									{{ $t("Me connecter") }}
								</a>
							</p>
						</div>
					</transition>

					<div class="container_btn">
						<s-button
							ref="toEtape2"
							class="w-full vs-con-loading__container"
							:disabled="errors.has('etape1.email') || accountAlreadyExist"
							@click="validateStep1"
						>
							{{ $t("Inscription gratuite") }}
						</s-button>
					</div>
				</template>

				<!-- Etape 2 : mot de passe -->
				<template v-if="step === 2">
					<div class="container_champs container_mdp">
						<vs-row>
							<vs-col style="padding-left: 0; position: relative">
								<vs-input
									ref="password"
									v-model="password"
									v-validate="'required|min:8'"
									name="password"
									:type="inputPasswordType"
									:placeholder="$t('Mot de passe')"
									data-vv-delay="300"
									color="var(--black)"
									class="w-full no-icon-border"
									icon-pack="feather"
									icon="icon icon-lock"
									@keydown.enter="validateStep2"
								/>

								<div class="eyeContainer" @click="toogleInputPasswordType()">
									<vs-icon
										v-if="inputPasswordType == 'password'"
										icon="visibility"
										color="var(--black)"
									></vs-icon>
									<vs-icon v-else icon="visibility_off" color="primary"></vs-icon>
								</div>
							</vs-col>
						</vs-row>

						<div v-show="errors.has('etape2.password') || passwordError.length > 0" class="form_error">
							<strong class="font-semibold"> {{ passwordError.length > 0 ? passwordError : "" }}</strong>
						</div>
					</div>

					<div class="container_btn">
						<s-button
							ref="toEtape3"
							class="vs-con-loading__container w-full"
							:disabled="!password || (passwordError.length > 0 && password.length < 8)"
							@click="validateStep2"
						>
							{{ $t("Suivant") }}
						</s-button>
					</div>
				</template>

				<!-- Etape 3 : prenom, nom et téléphone -->
				<template v-if="step === 3">
					<div class="container_champs flex">
						<div class="container_step3">
							<vs-input
								ref="firstname"
								v-model="firstname"
								v-validate="'required|alpha_spaces|min:2'"
								class="w-full"
								:placeholder="$t('Prénom')"
								name="firstname"
								type="text"
								data-vv-scope="etape3"
								data-vv-delay="300"
								color="var(--black)"
								@keydown.enter="validateStep3"
							/>

							<div v-show="errors.has('etape3.firstname')" class="form_error">
								<strong class="font-semibold">{{ errors.first("etape3.firstname") }}</strong>
							</div>
						</div>
						<div class="container_step3">
							<vs-input
								v-model="lastname"
								v-validate="'required|alpha_spaces|min:2'"
								class="w-full"
								:placeholder="$t('Nom')"
								name="lastname"
								type="text"
								data-vv-scope="etape3"
								data-vv-delay="300"
								color="var(--black)"
								@keydown.enter="validateStep3"
							/>

							<div v-show="errors.has('etape3.lastname')" class="form_error">
								<strong class="font-semibold">{{ errors.first("etape3.lastname") }}</strong>
							</div>
						</div>
						<!--
						<div class="container_step3">
							<vs-input
								v-model="phoneNumber"
								v-validate="'required|numeric'"
								class="w-full"
								:placeholder="$t('Téléphone')"
								name="phoneNumber"
								type="text"
								data-vv-scope="etape3"
								data-vv-delay="300"
								color="var(--black)"
								@keydown.enter="validateStep3"
							/>

							<div v-show="errors.has('etape3.phoneNumber')" class="form_error">
								<strong class="font-semibold">{{ errors.first("etape3.phoneNumber") }}</strong>
							</div>
						</div>
						-->
					</div>

					<!-- bouton de soumission -->
					<div class="container_btn">
						<s-button
							ref="toEtape4"
							class="vs-con-loading__container w-full"
							:disabled="!(lastname && firstname)"
							@click="validateStep3"
						>
							{{ $t("Suivant") }}
						</s-button>
					</div>
				</template>

				<!-- Etape 4 : nom de l'entreprise, secteur et taille -->
				<template v-if="step === 4">
					<div class="container_champs flex" @keyup.enter="enterClick">
						<div class="container_step4">
							<vs-input
								ref="appName"
								v-model="appName"
								v-validate="'required|min:3'"
								placeholder="Nom de votre entreprise"
								name="appName"
								type="text"
								class="w-full"
								data-vv-scope="etape4"
								data-vv-delay="300"
								color="var(--black)"
								@keyup.enter="enterClick"
							/>

							<div v-show="errors.has('etape4.appName')" class="form_error">
								<strong class="font-semibold">{{ errors.first("etape4.appName") }}</strong>
							</div>
						</div>
						<div v-if="display_organization_size_radio" class="container_step4">
							<vs-card
								style="
									border: 1px solid var(--border);
									border-radius: 5px;
									padding: 10px 0 0 0;
									padding-bottom: 0;
									margin-bottom: 0;
								"
								class="shadow-none"
								@keyup.enter="enterClick"
							>
								<vs-row style="margin-top: -7px; margin-bottom: -15px">
									<vs-col vs-w="12" style="padding-bottom: 15px; font-size: 14px; padding-left: 0">
										{{ $t("Taille de votre entreprise") }}
									</vs-col>
									<vs-col
										v-for="radio_size in sizes"
										:key="`size-${radio_size.value}`"
										vs-w="12"
										style="padding-left: 0"
									>
										<vs-radio
											v-model="size"
											vs-name="organization_size"
											:vs-value="radio_size.value"
										>
											{{ radio_size.text }}
										</vs-radio>
									</vs-col>
								</vs-row>
							</vs-card>
						</div>
						<!--div class="container_step4">
							<vs-select
								v-model="industry"
								v-validate="'required'"
								:placeholder="$t('Votre secteur d activité')"
								class="w-full"
								icon-pack="feather"
								icon="icon-arrow-down"
								@change="focus4"
							>
								<vs-select-item
									v-for="(item, index) in industries"
									:key="index"
									:value="item.value"
									:text="item.text"
								/>
							</vs-select>
						</div-->

						<!--div class="container_step4">
							<vs-select
								v-model="knowledge_marketing"
								v-validate="'required'"
								:placeholder="$t('Comment nous avez-vous connu ?')"
								class="w-full knowledges"
								icon-pack="feather"
								icon="icon-arrow-down"
								@change="focus4"
							>
								<vs-select-item
									v-for="(item, index) in knowledges"
									:key="index"
									:value="item.value"
									:text="item.text"
								/>
							</vs-select>
						</div-->
					</div>

					<div class="container_btn" @keyup.enter="enterClick">
						<s-button id="send4" class="w-full" :disabled="!appName || !size" @click="validateStep4">
							{{ $t("Créer mon compte") }}
						</s-button>
					</div>
				</template>
			</div>

			<!-- Etape 5 : chargement avant affichage de du lien d’acces a l'appli -->
			<div
				v-if="step === 5 || step === 6"
				class="register_form_end"
				:class="{ 'bgc-bleu form_end-1': step === 5, 'bgc-vert form_end-2': step === 6 }"
			>
				<transition name="fade" :duration="1000">
					<p v-if="step === 5" key="pEtape5" class="form_end_text pt-3">
						{{ $t("Veuillez patienter quelques secondes, nous créons votre application.") }}
					</p>
					<p v-else key="pEtape6" class="form_end_text pt-5 pb-3 mb-0">{{ $t("C’est prêt !") }}</p>
				</transition>
				<transition name="fade" :duration="1000">
					<div
						v-if="step === 5"
						ref="loader"
						key="divEtape5"
						class="form_end_action loader vs-con-loading__container"
					></div>
					<div v-else key="divEtape6" class="form_end_action flex">
						<div class="mx-auto">
							<s-button type="border" class="font-medium" @click="goToApp">
								{{ $t("Accéder à votre application") }}
							</s-button>
						</div>
					</div>
				</transition>
			</div>

			<transition name="fade">
				<p v-show="step === 0" class="register_text">
					<span class="whitespace-no-wrap inline-block mx-4">
						<span class="text-vert">✔</span> {{ $t("Pas de carte de crédit") }}
					</span>
					<span class="whitespace-no-wrap inline-block">
						<span class="text-vert">✔</span> {{ $t("Sans engagement") }}
					</span>
				</p>
			</transition>

			<div v-if="shopify_redirect" class="container_btn">
				<vs-button class="vs-con-loading__container bgc-bleu w-full" @click="goToShopify">
					{{ $t("Connexion à mon compte Sinao") }}
				</vs-button>
			</div>
		</div>
	</div>
</template>

<script>
	import "vue-form-wizard/dist/vue-form-wizard.min.css";
	import { Validator } from "vee-validate";
	import { mapState } from "vuex";
	import i18n from "../i18n";

	const dictionary = {
		custom: {
			email: {
				required: () => i18n.t("Vous devez entrer un e-mail"),
				email: () => i18n.t("Vous devez entrer un e-mail valide")
			},
			password: {
				required: () => i18n.t("Vous devez entrer un mot de passe"),
				min: () => i18n.t("Le mot de passe doit contenir au moins 8 caractères")
			},
			cgu: {
				included: () => i18n.t("Vous devez accepter les conditions générales d’utilisation")
			},
			firstname: {
				required: () => i18n.t("Vous devez entrer un prénom"),
				alpha_spaces: () => i18n.t("Le prénom ne peut contenir que des lettres ou des espaces"),
				min: () => i18n.t("Votre prénom doit contenir au moins 2 caractères")
			},
			lastname: {
				required: () => i18n.t("Vous devez entrer un nom"),
				alpha_spaces: () => i18n.t("Le nom ne peut contenir que des lettres ou des espaces"),
				min: () => i18n.t("Votre nom doit contenir au moins 2 caractères")
			},
			phoneNumber: {
				required: () => i18n.t("Vous devez entrer un numéro de téléphone"),
				numeric: () => i18n.t("Le numéro de téléphone ne doit contenir que des chiffres")
			},
			appName: {
				required: () => i18n.t("Veuillez entrer le nom de votre entreprise"),
				min: () => i18n.t("Votre nom de votre entreprise doit contenir au moins 3 caractères")
			}
		}
	};

	export default {
		name: "Register",
		data() {
			return {
				branding: null,
				isWhitelabel: false,
				step: 1,
				email: null,
				password: null,
				firstname: null,
				lastname: null,
				phoneNumber: null,
				appName: null,
				cgu: true,
				accountAlreadyExist: false,
				appUrl: null,
				appIdentifiant: null,
				token: null,
				industry: null,
				knowledge_marketing: null,
				industries: [
					{ text: i18n.t("Votre secteur d’activité"), value: null },
					{ text: i18n.t("Action sociale"), value: "social_work" },
					{ text: i18n.t("Administration"), value: "administrative" },
					{ text: i18n.t("Agriculture"), value: "agriculture" },
					{ text: i18n.t("Artisan"), value: "artisan" },
					{ text: i18n.t("Commerce"), value: "trade" },
					{ text: i18n.t("Construction / BTP"), value: "construction" },
					{ text: i18n.t("E-commerce"), value: "ecommerce" },
					{ text: i18n.t("Enseignement"), value: "education" },
					{ text: i18n.t("Études et conseils"), value: "consulting" },
					{ text: i18n.t("Finance / Assurance / Immobilier"), value: "finance_real_estate_insurance" },
					{ text: i18n.t("Hébergement / Restauration"), value: "lodging_catering" },
					{ text: i18n.t("Industrie"), value: "industry" },
					{ text: i18n.t("Information / Communication"), value: "information_communication" },
					{ text: i18n.t("Informatique / Télécoms"), value: "it_telecom" },
					{ text: i18n.t("Santé"), value: "health" },
					{ text: i18n.t("Services"), value: "services" },
					{ text: i18n.t("Transport / Logistique"), value: "transport_logistics" }
				],
				sizes: [
					{ text: i18n.t("Vous travaillez seul"), value: "solo" },
					{ text: i18n.t("1 à 5 salariés"), value: "small" },
					{ text: i18n.t("6 salariés et plus"), value: "medium" }
				],
				knowledges: [
					{ text: i18n.t("Comment nous avez-vous connu ?"), value: null },
					{ text: i18n.t("Youtube"), value: "youtube" },
					{ text: i18n.t("Réseaux sociaux"), value: "social_media" },
					{ text: i18n.t("Experts-comptables"), value: "chartered_accountant" },
					{ text: i18n.t("Autres partenaires"), value: "partenership" },
					{ text: i18n.t("Amis, Réseaux"), value: "friend_supplier" },
					{ text: i18n.t("Articles"), value: "article" },
					{ text: i18n.t("Comparateurs"), value: "Comparators" },
					{ text: i18n.t("Internet"), value: "internet" }
				],
				inputPasswordType: "password",
				referrerValue: null,
				referrerName: null,
				etape4_error: ""
			};
		},
		computed: {
			...mapState([
				"utm",
				"shopify",
				"shopify_redirect",
				"organization_size",
				"display_organization_size_radio",
				"isLicensed",
				"accountManagerUrl"
			]),
			passwordError() {
				if (this.password?.length < 8)
					return i18n.t("Le mot de passe doit contenir au moins 8 caractères sans espace");

				if (/\s/.test(this.password)) return i18n.t("Le mot de passe ne doit pas contenir d’espace");

				return "";
			},
			size: {
				get() {
					return this.organization_size;
				},
				set(newSize) {
					this.$store.commit("organization_size", newSize);
				}
			}
		},
		async mounted() {
			this.setReferrer();
			Validator.localize("fr", dictionary);

			this.branding = await this.$store.dispatch("branding");
		},
		methods: {
			focus4() {
				document.getElementById("send4").focus();
			},
			enterClick() {
				if (this.step === 4) this.validateStep4();
			},
			toogleInputPasswordType() {
				this.inputPasswordType = this.inputPasswordType === "password" ? "text" : "password";
			},
			async validateStep1() {
				const isFormValid = await this.$validator.validate("etape1.*");

				if (isFormValid) {
					this.$vs.loading({
						type: "default",
						color: "var(--white)",
						background: "var(--primary)",
						container: this.$refs.toEtape2.$el,
						scale: 0.5
					});

					let { email } = this;

					this.$store.dispatch("checkIfUserExist", email).catch(error => {
						const status = error.response.status;

						// Si on recoit un 404 l'email n'est pas connue on peut continuer
						if (status === 404) {
							window.dataLayer.push({
								sinao_email: email,
								event: "sinaoregister-email"
							});

							this.step = 2;

							this.$vs.loading.close(this.$refs.toEtape2.$el);

							this.$nextTick(() => this.setFocus("password"));
						} else if (status === 401 || status === 422) {
							window.dataLayer.push({
								sinao_email: email,
								event: "sinaoregister-email-exists"
							});

							this.accountAlreadyExist = true;

							this.$vs.loading.close(this.$refs.toEtape2.$el);

							this.resetFocus();
						} else {
							this.$vs.dialog({
								type: "alert",
								color: "danger",
								title: "Oups !",
								text: i18n.t(
									"Une erreur est survenue, veuillez vérifier votre connexion internet et si le problème persiste à contacter le support."
								)
							});
						}
					});
				}
			},
			async validateStep2() {
				if (!this.password || this.passwordError.length > 0) return;

				const isFormValid = await this.$validator.validate("etape2.*");

				if (isFormValid) {
					this.$vs.loading({
						type: "default",
						color: "var(--white)",
						background: "var(--primary)",
						container: this.$refs.toEtape3.$el,
						scale: 0.5
					});

					const { email, password } = this;
					const cgu = this.cgu ? 1 : 0;

					try {
						this.$store
							.dispatch("register", { email, password, cgu, metadata: { ...this.shopify } })
							.then(response => {
								window.dataLayer.push({
									sinao_user: response,
									event: "sinaoregister-user"
								});

								this.$store
									.dispatch("login", { email, password })
									.then(response2 => {
										this.token = response2?.access_token;

										this.step = 3;

										this.$vs.loading.close(this.$refs.toEtape3.$el);

										this.$nextTick(() => this.setFocus("firstname"));
									})
									.catch(error => {
										console.log(error);

										this.step = 2;
									});
							});
					} catch (error) {
						this.$vs.loading.close(this.$refs.toEtape3.$el);

						this.resetFocus();

						// Compte deja existant
						if (error.response.status === 422) {
							this.accountAlreadyExist = true;
						} else {
							this.$vs.dialog({
								type: "alert",
								color: "danger",
								title: "Oups !",
								text: i18n.t(
									"Une erreur est survenue, veuillez vérifier votre connexion internet et si le problème persiste à contacter le support."
								)
							});
						}
					}
				}
			},
			async validateStep3() {
				const isFormValid = await this.$validator.validate("etape3.*");

				if (isFormValid) {
					this.$vs.loading({
						type: "default",
						color: "var(--white)",
						background: "var(--primary)",
						container: this.$refs.toEtape4.$el,
						scale: 0.5
					});

					const { firstname, lastname, token } = this;

					try {
						this.$store.dispatch("updateUser", { firstname, lastname, token }).then(response => {
							window.dataLayer.push({
								sinao_user: response,
								event: "sinaoregister-infos"
							});

							this.step = 4;

							this.$vs.loading.close(this.$refs.toEtape4.$el);

							this.$nextTick(() => this.setFocus("appName"));
						});
					} catch (error) {
						this.$vs.loading.close(this.$refs.toEtape4.$el);

						this.resetFocus();

						this.$vs.dialog({
							type: "alert",
							color: "danger",
							title: "Oups !",
							text: i18n.t(
								"Une erreur est survenue, veuillez vérifier votre connexion internet et si le problème persiste à contacter le support."
							)
						});
					}
				}
			},
			async validateStep4() {
				//const isFormValid_v_validate = await this.$validator.validate("etape4.*");
				const isFormValid = this.appName && this.appName.length >= 3 && this.size; //&& this.knowledge_marketing && this.industry;

				if (isFormValid) {
					this.step = 5;

					this.$nextTick(() => {
						this.$vs.loading({
							type: "default",
							color: "var(--white)",
							background: "var(--primary)",
							container: this.$refs.loader,
							scale: 0.8
						});
					});

					try {
						const {
							appName,
							token,
							size,
							industry,
							phoneNumber,
							referrerValue,
							email,
							knowledge_marketing
						} = this;

						let domain = "sinao.app";

						try {
							domain = this.branding?.domain;
						} catch (error) {
							console.log(error);
						}

						try {
							const response = await this.$store.dispatch("createApp", { appName, token, domain, size });

							window.dataLayer.push({
								sinao_app: response,
								event: "sinaoregister-app"
							});

							this.step = 6;

							const { url, id, identifiant } = response;

							this.appUrl = url;
							this.appIdentifiant = identifiant;

							this.$store.dispatch("activateSponsorship", {
								appId: id,
								token: token,
								referrer_id: referrerValue,
								email: email
							});

							this.$store
								.dispatch("updateOrganization", { appId: id, token, phoneNumber, industry, size })
								.then(_ => {
									// if (this.shopify) {
									// 	this.$store.dispatch("updateAppSettings", {
									// 		appId: id,
									// 		token: token,
									// 		data: { shopify: this.shopify }
									// 	});
									// }

									this.$store
										.dispatch("updateAppSettings", {
											appId: id,
											token: token,
											data: {
												shopify: this.shopify,
												utm: this.utm,
												knowledge_marketing: knowledge_marketing,
												sponsorship: referrerValue ? "1" : "0"
											}
										})
										.then(_ => {
											setTimeout(() => {
												this.goToApp();
											}, 1000);
										});
								});
						} catch (error) {
							// Rate Limiter restiction alert
							if (/429/g.test(error)) {
								return this.$vs.dialog({
									title: "Attention",
									text: i18n.t(
										"Nous avons detecté trop de tentatives de création d’application Sinao. Recommencez dans une heure ou contactez le support."
									),
									color: "danger",
									type: "confirm",
									accept: () => {
										this.step = 4;
									},
									cancel: () => {
										this.step = 4;
									}
								});
							}
						}
					} catch (error) {
						this.resetFocus();

						this.$vs.dialog({
							type: "alert",
							color: "danger",
							title: "Oups !",
							text: i18n.t(
								"Une erreur est survenue, veuillez vérifier votre connexion internet et si le problème persiste à contacter le support."
							)
						});
					}
				} else {
					this.etape4_error = "Veuillez remplir tous les champs";
					setTimeout(() => {
						this.etape4_error = "";
					}, 3000);
				}
			},
			goToApp() {
				window.dataLayer.push({
					event: "sinaoregister-redirect"
				});

				let url = `${this.appUrl}?login=${this.token}`;
				if (!this.appUrl.includes("sinao.app"))
					url = `${this.appUrl}sso/login?session_token=${this.token}&redirect_url=${this.appIdentifiant}`;

				if (this.shopify_redirect) {
					const qs = Object.keys(this.shopify)
						.map(key => `${key}=${this.shopify[key]}`)
						.join("&");

					url = `https://shopify.sinao.app/login?token=${this.token}&${qs}`;
				}

				console.log("[Register] – Final redirect URL:", url);
				console.log("[Register] – window.parent:", window.parent);

				if (window.parent) {
					window.parent.location.href = url;
				} else {
					window.location.href = url;
				}
			},
			goToShopify() {
				let url = `${this.appUrl}?login=${this.token}`;

				const qs = Object.keys(this.shopify)
					.map(key => `${key}=${this.shopify[key]}`)
					.join("&");

				url = `https://shopify.sinao.app/login?token=${this.token}&${qs}`;

				if (window.parent) {
					window.parent.location.href = url;
				} else {
					window.location.href = url;
				}
			},
			openPage(path, account = false) {
				if (path === "cgu" && this.isLicensed) {
					window.open(`https://drive.google.com/file/d/15jHPpNURxWWbmQmpwuETk77EWQUkDQLq/view`);
				} else {
					var url = account ? process.env.VUE_APP_ACCOUNT_URL : process.env.VUE_APP_WEBSITE_URL;
					if (this.isLicensed) url = this.accountManagerUrl || url;

					window.open(`${url}/${path}`);
				}
			},
			setFocus(input) {
				if (this.$refs[input] && this.$refs[input].$el) {
					this.$refs[input].$el.querySelector("input").focus();
				}
			},
			resetFocus() {
				document.activeElement.blur();
			},
			setReferrer() {
				const referrer = this.getCookie();

				if (referrer && referrer.value && referrer.name) {
					this.referrerValue = referrer.value;
					this.referrerName = referrer.name;
				}
			},
			getCookie() {
				const cookies = document.cookie.split("; ");
				let i = 0;
				let sponsorship = null;

				while (i < cookies.length && !sponsorship) {
					const cookie = cookies[i].split("=");
					i++;

					if (cookie[0].trim() === "sponsorship") {
						sponsorship = JSON.parse(cookie[1]);
					}
				}

				return sponsorship;
			}
		}
	};
</script>

<style>
	.con-select .vs-select--input {
		/* min-height: 45px;
		border-radius: 5px;
		box-shadow: rgb(0 0 0 / 11%) 0px 2px 4px 0px; */
	}

	@font-face {
		font-family: "Asap";
		src: local("Asap Medium"), local("Asap-Medium"),
			url("https://fonts.gstatic.com/s/asap/v11/KFOnCniXp96aw8g99UtvBg.woff2") format("woff2");
		font-style: normal;
		font-weight: 500;
		unicode-range: U+0-FF, U+131, U+152-153, U+2BB-2BC, U+2C6, U+2DA, U+2DC, U+2000-206F, U+2074, U+20AC, U+2122,
			U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
	}
	body {
		font-family: "Open Sans", sans-serif;
	}
	.register {
		height: 12rem;
	}
	.register_form_container {
		display: grid;
		grid-template-areas: "label label" "champs btn" "checkbox checkbox" "erreur erreur";
		grid-template-columns: 1fr auto;
		width: 100%;
		row-gap: 0.5em;
	}
	.register_form_end {
		display: grid;
		grid-template-areas: "text" "action";
		grid-template-rows: 1fr 1fr;
		height: 100%;
		border-radius: 0.75em;
		text-align: center;
		overflow: hidden;
		transition: background-color 500ms ease-in-out;
		/* box-shadow: 0px 4px 4px 0px #0000001c; */
	}
	.eyeContainer {
		cursor: pointer;
		position: absolute;
		right: 0.75rem;
		top: 50%;
		transform: translateY(-50%);
		padding-right: 12px;
		height: 24px;
	}
	.register_text {
		text-align: center;
		font-size: 12px;
	}
	button[name="button"].bgc-bleu,
	.bgc-bleu {
		background-color: var(--primary) !important;
	}
	button[name="button"].bgc-green,
	.bgc-green {
		background-color: #16a34a !important;
		opacity: 0.9;
	}
	.bgc-green:hover {
		opacity: 0.8;
	}
	a.text-lien,
	a.text-lien:visited {
		color: var(--link);
		font-weight: 500;
	}
	.text-vert {
		color: var(--success) !important;
	}
	.checkbox:focus {
		outline: dotted thin;
		outline-offset: 1px;
	}
	.bgc-vert {
		background-color: var(--success) !important;
	}
	.form_end-2 {
		grid-template-rows: 45% 55%;
	}
	.form_end_text {
		grid-area: text;
		color: white;
		font-family: "Asap", sans-serif;
		font-weight: 500;
		font-size: 20px;
		margin: auto;
		padding: 0 50px;
		line-height: 25px;
	}
	.form_end_action {
		grid-area: action;
	}
	.form_error {
		/* grid-area: erreur; */
		background-color: #ffe5e9;
		color: var(--danger);
		width: 100%;
		padding: 0.5em 1em;
		border-radius: 0.5em;
		margin: 0.5em 0;
	}
	.container_label {
		grid-area: label;
		display: flex;
		flex-direction: row;
	}
	.container_champs {
		grid-area: champs;
		display: flex;
		flex-direction: row;
	}
	.container_accountAlreadyExist {
		grid-area: erreur;
	}
	.container_btn {
		grid-area: btn;
		padding-left: 0.75rem;
	}
	.container_checkbox {
		grid-area: checkbox;
		display: grid;
		grid-template-columns: 100%;
		align-items: center;
	}
	.container_mail {
		flex-direction: column;
	}

	.container_step3 {
		width: 30%;
		margin-right: 3.3%;
	}

	.container_step4 {
		width: 30%;
		margin-right: 3.3%;
	}

	.vs-select--options.vs-select-primary {
		height: 150px;
		overflow-y: auto;
	}

	@media screen and (max-width: 600px) {
		.container_champs {
			flex-direction: column;
		}
		.container_btn {
			padding: 0;
		}
		.container_mdp {
			width: 100%;
			flex-direction: column;
		}

		.container_step3 {
			width: 100%;
			margin: 0;
			padding-top: 0.5rem;
		}

		.container_step4 {
			width: 100%;
			margin: 0;
			padding-top: 0.5rem;
		}

		.register_form_container {
			grid-template-areas: "label" "champs" "checkbox" "erreur" "btn";
		}
	}
	.vs-button {
		font-weight: 400;
	}
	.loader {
		position: relative;
		width: 100%;
		height: 100%;
	}
	.label_text {
		color: var(--title);
		font-family: "Asap", sans-serif;
		font-weight: 500;
		font-size: 1.1rem;
	}
	.etapes {
		display: flex;
		flex-direction: row;
		align-items: center;
		margin: 0 0.75rem 0 auto;
	}
	.step {
		display: block;
		width: 1em;
		height: 1em;
		background-color: var(--border);
		border-radius: 50%;
		margin: 0.25em;
	}
	.step-active {
		background-color: var(--primary);
		border: solid var(--white) 0.2em;
		box-shadow: #00000044 0 0.1em 0.25em;
	}

	/* transition entrante du label et de la checkbox */
	.pop-enter {
		max-height: 0em;
		opacity: 0;
	}
	.pop-enter-active {
		transition: max-height 0.5s 0s ease-in-out, opacity 0.25s 0.15s ease-in;
	}
	.pop-enter-to {
		max-height: 5em;
		opacity: 1;
	}

	/* transition entre step 5 et 6 */
	.fade-between-enter {
		opacity: 0;
	}
	.fade-between-active {
		transition: opacity 0.5s ease-in-out;
	}
	.fade-between-enter-to {
		opacity: 1;
	}
	.fade-between-leave {
		opacity: 1;
	}
	.fade-between-leave-to {
		opacity: 0;
	}
	.sponsorship {
		background-color: #c6eaad !important;
		padding: 5px 10px;
		border-radius: 4px;
		width: fit-content;
		margin: auto;
		margin-bottom: 10px;
	}
</style>
